import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import { useQuery } from "@tanstack/react-query";
import BaseApiDropdown from "./BaseApiDropdown";
import { useSearchQuery } from "../hooks";

interface Props extends DropdownWithoutOptionsProps<server.dto.GooglePlaceAutocomplete, string> {
  type: "transit_station"
}

const GooglePlacesApiDropdown = (props: Props) => {
  const searchQuery = useSearchQuery();

  const query = useQuery({
    queryKey: ["googleplaces", props.type, searchQuery.searchQuery],
    queryFn: async () => window.Api.GooglePlaces.TextSearch(searchQuery.searchQuery, props.type).then(r => r.data),
    initialData: []
  });

  return <BaseApiDropdown<server.dto.GooglePlaceAutocomplete, string>
    excludeKeys={props.excludeKeys}
    query={query}
    searchQuery={searchQuery}
    getLabel={item => item.name}
    getSubLabel={item => item.address}
    getValue={item => item.placeId}
    onChange={props.onChange}
    value={props.value}
    config={props.config}
    options={query.data}
  />;
};

export default GooglePlacesApiDropdown;